import { z } from 'zod'

export const formSchema = z.object({
  name: z.string().min(1),
  email: z.string().optional(),
  phone: z.string().optional(),
  tags: z
    .string()
    .optional()
    .refine(
      (tags) => {
        const split = tags?.split(/\s*,\s*/)
        const validTags = split?.filter((x) => x.trim().length > 0) ?? []
        return validTags.length <= 5
      },
      {
        message: 'You can only add up to 5 tags.',
      }
    ),
})
